import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
require("es6-promise/auto");
Es6Promise.polyfill()
import Vue from 'vue' 
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/reset.css'
import './assets/js/rem'

import Vant from 'vant';
import 'vant/lib/index.css';
import axios from "./assets/js/axios";
import request from '@/assets/js/request'
Vue.prototype.request =request
Vue.prototype.axios = axios
Vue.use(Vant);
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import './assets/js/macarons';

Vue.config.productionTip = false

// 判断是否在小程序环境，在的话根据参数添加动态路由
var ua = navigator.userAgent.toLowerCase();
if(ua.match(/MicroMessenger/i)=="micromessenger") {
    //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
    wx.miniProgram.getEnv((res)=>{
      if (res.miniprogram) {
        let arr = window.location.pathname.split('/')
        let str = arr[arr.length-1]
        router.addRoutes([
          {
              path: '/'+str,
              name: 'Index',
              component: () => import('./views/index.vue')
          }
        ])

      } else {
      }
    })
}else{
}

router.beforeEach((to,from,next)=>{
  if(sessionStorage.getItem('title')){
    document.title = sessionStorage.getItem('title');
  }else {
    document.title='欢迎使用博思统一缴费平台'
  }
  next()
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
